import { Avatar, Button, Card, Col, Form, Grid, Input, List, Row } from 'antd';
import { Modal } from 'components';
import dayjs from 'dayjs';
import { useCreateComments } from 'features/document-report/use-cases/create-comments';
import { useCommentsList } from 'features/document-report/use-cases/get-comments';
import { useUserContext } from 'features/users';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { Folder, SendHorizontal } from 'lucide-react';
import { useState } from 'react';

const { useBreakpoint } = Grid;

export const CommentsItemView = ({
  onClose,
  commentsInfo,
  getDocumentsCount,
}: {
  onClose: () => void;
  commentsInfo: any;
  getDocumentsCount: any;
}) => {
  // const { user } = useUserContext();
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [form] = Form.useForm();
  const { user } = useUserContext();
  const [newComment, setNewComment] = useState('');
  const { companyId, documentId } = commentsInfo || {};
  // Fetch comments
  const { data: commentsData, isLoading: commentsFetch } = useCommentsList({
    CompanyId: companyId || user?.CompanyId,
    DocumentId: documentId,
  } as any);

  const { isLoading, mutate } = useCreateComments();

  const handleAddComment = () => {
    const IsAdmin: any = false;
    if (!newComment.trim()) return;
    const formData = new FormData();
    // formData.append('CompanyId', user?.CompanyId);
    formData.append('DocumentId', documentId);
    formData.append('Comments', newComment);
    formData.append('IsAdmin', IsAdmin);

    mutate(formData, {
      onSuccess: () => {
        setNewComment('');
        getDocumentsCount();
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        title={'Comments'}
        onCancel={onClose}
        getContainer={false}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        maskClosable={false}
        okButtonProps={{
          style: { display: 'none' }, // Hides the Save button
        }}
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          margin: 0,
          height: '100vh',
          padding: 0,
        }}
        bodyStyle={{
          height: 'calc(100vh - 55px)',
          overflowY: 'auto',
          borderRadius: 0,
        }}
        className='comments-modal'
      >
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          disabled={isLoading}
        >
          <Card className='mb-4 bg-[#F6F7F9] lgl_crd border-0'>
            <div className='flex gap-2'>
              <div>
                <div className='bg-white p-2 rounded-lg mr-3'>
                  <Folder fill='#D7DAEB' stroke='none' size={50} />
                </div>
              </div>
              <div className='flex flex-col grow'>
                <div className='flex'>
                  <p className='font-bold text-black mr-2'>
                    {commentsInfo?.documentName}
                  </p>
                  {commentsInfo?.categoryName && (
                    <span className='bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded leading-5 mr-2'>
                      {commentsInfo?.categoryName}
                    </span>
                  )}
                  {commentsInfo?.subCategoryName && (
                    <span className='bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded leading-5'>
                      {commentsInfo?.subCategoryName}
                    </span>
                  )}
                </div>
                <span className='block text-xs mt-1'>
                  {dayjs(commentsInfo?.lastUpdatedDate).format('DD-MMM-YYYY')}
                </span>
              </div>
            </div>
          </Card>

          <div className='main_cm'>
            <h3 className='text-[#272C2A] text-lg font-bold mb-2'>Comments</h3>

            <div className='bg-[#F5F6FA] p-4 rounded'>
              <Row style={{ marginBottom: '10px', width: '100%' }}>
                <List
                  style={{ width: '100%' }}
                  size='small'
                  loading={commentsFetch}
                  className='list_cstm'
                  // header={<div>Comments</div>}
                  dataSource={commentsData?.rc?.[0]?.commentsList || []}
                  renderItem={(item: any) => (
                    <List.Item>
                      <List.Item.Meta
                        // avatar={<Avatar src={item.profileImage} />}
                        title={
                          <div>
                            <div className='flex mb-2'>
                              <div className='w-10 h-10 rounded-full overflow-hidden mr-4'>
                                {/* <img
                                  src={item.profileImage}
                                  alt=''
                                  className='w-full h-full'
                                /> */}
                                <Avatar src={item.profileImage} />
                              </div>
                              <div>
                                <span className='text-black font-bold'>
                                  {item.commentBy}
                                </span>
                                <span className='text-xs text-[#959CA7] block'>
                                  {dayjs(item.commentOn).format(
                                    'DD-MM-YYYY HH:mm',
                                  )}
                                </span>
                              </div>
                            </div>
                            <p className='text-[#383838]'>{item.comments}</p>
                          </div>
                        }
                        // description={item.comments}
                      />
                    </List.Item>
                  )}
                />
              </Row>

              <Row>
                <Col span={24}>
                  <div className='grid grid-cols-[1fr_70px]'>
                    <Input.TextArea
                      rows={2}
                      placeholder='Add a comment'
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      className='border-0 bg-white placeholder:text-[#253B72] hover:border-0'
                    />
                    <Button
                      type='primary'
                      onClick={handleAddComment}
                      loading={isLoading}
                      className='rounded-full w-12 h-12 flex justify-center items-center p-0 ml-3'
                    >
                      <SendHorizontal stroke='#fff' />
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
